import React from "react";
import { useLang } from "@/context/LangContext";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-[#1A0010] text-[#FBF9F6] relative overflow-hidden">
      <div className="grain" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="overline">Cabinet Individual de Avocat</p>
            <h3 className="display mt-3 text-4xl md:text-5xl text-[#FBF9F6]">
              Martiș <span className="italic text-[#D4AF37]">Biatrice-Olimpia</span>
            </h3>
            <div className="hairline-strong w-20 mt-7" />
            <p className="mt-7 text-[#FBF9F6]/70 max-w-md text-[15px] leading-relaxed">
              {t.footer.legal}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Contact</p>
            <ul className="mt-5 space-y-3 text-[#FBF9F6]/80 text-[15px]">
              <li>0720 201 887</li>
              <li>Str. Brăilei nr. 153, Galați</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline">Navigare</p>
            <ul className="mt-5 space-y-3 text-[15px]">
              {[
                ["about", t.nav.about],
                ["services", t.nav.services],
                ["blog", t.nav.blog],
                ["contact", t.nav.contact],
              ].map(([id, l]) => (
                <li key={id}>
                  <a href={`#${id}`} className="text-[#FBF9F6]/80 hover:text-[#D4AF37] transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#D4AF37]/25 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-[#FBF9F6]/55">
          <p>© {new Date().getFullYear()} Cabinet Avocat Martiș Biatrice-Olimpia. {t.footer.rights}</p>
          <p className="serif italic">Lex semper certa est.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
